import React from 'react';
import './Transport1.css';
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import metro from '../../asserts/images/gare-monastir.jpg';
import Louage from '../../asserts/images/louage.jpg';
import Bus from '../../asserts/images/bus1.png';
import Restaurant from '../../asserts/images/restaurant.jpg';
import foyer from '../../asserts/images/foyer.jpg';

function Transport1(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header />
       <div className='bgtransport'>  </div>
      <div className="container-fluid text-white text-center" style={{position:'relative',marginTop:'-120px',marginBottom:'100px'}}>
         <h1 className="container-fluid text-white text-center" style={{fontSize:'45px'}} id='h1trans'>Vie Universitaire</h1>
       <p><Link className='linktransport' to="/">Accueil</Link> <span>{'>'}</span> <Link className='linktransport'>Vie étudiante</Link> <span>{'>'}</span> <Link className='linktransport'
           to="/Transport">Vie Universitaire</Link></p>
        </div>
        <div className='transport1'>
        <div class="container-fluid text-center">
       <h1 class="container-fluid text-center" >Transport Publique </h1></div>
 
            <div className='transportpub'>
            <h3 class="container-fluid text-center"style={{fontFamily:'Poppins, sans-serif'}}>Station Métro</h3>
             <div className='vehicule'><img src={metro} alt="metro"  /> </div>
            <p className='vehiculeP'>voir la localisation sur la carte :</p>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.1933626934156!2d10.825290737288833!3d35.770626260772936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212ca531694fb%3A0x927f1b1f8d3f7082!2sMonastir!5e0!3m2!1sfr!2stn!4v1707862407818!5m2!1sfr!2stn" 
              width="400" height="250" 
              style={{ border: 0 }}
              allowfullscreen=""
               loading="lazy" 
               referrerpolicy="no-referrer-when-downgrade">
                </iframe>          

            </div>
            <div className='transportpub'>
            <h3 class="container-fluid text-center" style={{fontFamily:'Poppins, sans-serif'}}>Station Louage</h3>
                <div className='vehicule'><img src={Louage} alt="Louage"  /> </div>
                
                <p className='vehiculeP'>voir la localisation sur la carte :</p>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.1463799311196!2d10.823194175254692!3d35.77178047499544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212cb2f53f32f%3A0x9222fc6e26b3acb1!2sStation%20Louage%20Monastir!5e0!3m2!1sfr!2stn!4v1707862156025!5m2!1sfr!2stn"
                        style={{ border: 0 }}     
                        width="400" height="250"    
                        allowfullscreen="" loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade">
         </iframe>       
            </div>
            <div className='transportpub'>
            <h3 class="container-fluid text-center" style={{fontFamily:'Poppins, sans-serif'}}>Station Bus</h3>
            <div className='vehicule'> <img src={Bus} alt="Bus"  />  </div>
            <p className='vehiculeP'>voir la localisation sur la carte :</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.089588028869!2d10.823195675254814!3d35.773175624918636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212cb28d5cc11%3A0xc95062f66314674a!2sStation%20STS%20Monastir!5e0!3m2!1sfr!2stn!4v1707861990381!5m2!1sfr!2stn" 
                    style={{ border: 0 }}     
              width="400" height="250"         
              allowfullscreen="" loading="lazy"
               referrerpolicy="no-referrer-when-downgrade">
     </iframe>      
            </div>
            


        </div>
        <div className='transport1'>
        <div class="container-fluid text-center">
       <h1 class="container-fluid text-center" >Restaurant et Foyer Universitaire </h1></div>
 
            <div className='transportpub'>
            <h3 class="container-fluid text-center" style={{fontFamily:'Poppins, sans-serif'}}>Restaurant</h3>
             <div className='vehicule'>  <img src={Restaurant} alt="metro" /> </div>
            
            <p className='vehiculeP'>voir la localisation sur la carte :</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.3199717749976!2d10.832640775254498!3d35.76751572523014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130213efcb7b7f8b%3A0x21e902fdcd3376bb!2sRestaurant%20Universitaire%20Fatouma!5e0!3m2!1sfr!2stn!4v1707864134946!5m2!1sfr!2stn"
        style={{ border: 0 }}
        width="400" height="250"
        allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
       

            </div>


 
          
            <div className='transportpub'>
            <h3 class="container-fluid text-center" style={{fontFamily:'Poppins, sans-serif'}}>Foyer</h3>
            <div className='vehicule'>      <img src={foyer} alt="foyer" /></div>
            <p className='vehiculeP'>voir la localisation sur la carte :</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.3376053805431!2d10.836242392388959!3d35.7667676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212d191c83a99%3A0x91edf99dbe046290!2sFoyer%20Fattouma%20Bourguiba!5e0!3m2!1sfr!2stn!4v1707864005197!5m2!1sfr!2stn"
        style={{ border: 0 }}
        width="400" height="250"
        allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
      </iframe>
    
            </div>
            


        </div>
        


      <Footer />
    </div>
  )
}

export default Transport1;

/**
 * 
 * 
<div className="container mt-5">
<div class="container-fluid text-center">
  <h1 style={{marginLeft:'-230px'}}>Transport Publique </h1>
  <br/>
</div>
  <div className="row"  style={{flexWrap:'wrap',display:'flex',paddingottom:'50px'}}>
    <div className="col-sm-4">
      <h3 className='TITRETRANSPORT'>Station Métro</h3>
      <img src={metro} alt="metro"  /> 
      <br/> <br/>
      <p>voir la localisation sur la carte :</p>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.1933626934156!2d10.825290737288833!3d35.770626260772936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212ca531694fb%3A0x927f1b1f8d3f7082!2sMonastir!5e0!3m2!1sfr!2stn!4v1707862407818!5m2!1sfr!2stn" 
              width="400" height="250" 
              style={{ border: 0 }}
              allowfullscreen=""
               loading="lazy" 
               referrerpolicy="no-referrer-when-downgrade">
                </iframe>          

    </div>
    <div className="col-sm-4">
      <h3 className='TITRETRANSPORT'>Station Bus</h3>
      <img src={Bus} alt="Bus"  /> 
      <br/> <br/>
      <p>voir la localisation sur la carte :</p>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.089588028869!2d10.823195675254814!3d35.773175624918636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212cb28d5cc11%3A0xc95062f66314674a!2sStation%20STS%20Monastir!5e0!3m2!1sfr!2stn!4v1707861990381!5m2!1sfr!2stn" 
              style={{ border: 0 }}     
              width="400" height="250"         
              allowfullscreen="" loading="lazy"
               referrerpolicy="no-referrer-when-downgrade">
     </iframe>          

    </div>
    <div className="col-sm-4">
      <h3 className='TITRETRANSPORT'>Station Louage</h3>
      <img src={Louage} alt="Louage"  /> 
      <br/> <br/>
      <p>voir la localisation sur la carte :</p>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.1463799311196!2d10.823194175254692!3d35.77178047499544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212cb2f53f32f%3A0x9222fc6e26b3acb1!2sStation%20Louage%20Monastir!5e0!3m2!1sfr!2stn!4v1707862156025!5m2!1sfr!2stn"
            style={{ border: 0 }}     
            width="400" height="250"    
             allowfullscreen="" loading="lazy" 
             referrerpolicy="no-referrer-when-downgrade">
         </iframe>         
    </div>
    
  </div>
</div>
<div className="container mt-5">
  <div className="container-fluid text-center">
    <h1 style={{ marginLeft: '-180px' }}>Restaurant et Foyer Universitaire</h1>
    <br />
  </div>
  <div className="row justify-content-center">
    <div className="col-sm-4 text-center">
      <h3 className='TITRETRANSPORT1'>Restaurant</h3>
      <img src={Restaurant} alt="metro" />
      <br /> <br />
      <p>voir la localisation sur la carte :</p>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.3199717749976!2d10.832640775254498!3d35.76751572523014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130213efcb7b7f8b%3A0x21e902fdcd3376bb!2sRestaurant%20Universitaire%20Fatouma!5e0!3m2!1sfr!2stn!4v1707864134946!5m2!1sfr!2stn"
        style={{ border: 0 }}
        width="400" height="250"
        allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

    </div>
    <div className="col-sm-4 text-center">
      <h3 className='TITRETRANSPORT1'>Foyer</h3>
      <img src={foyer} alt="Bus" />
      <br /> <br />
      <p>voir la localisation sur la carte :</p>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.3376053805431!2d10.836242392388959!3d35.7667676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212d191c83a99%3A0x91edf99dbe046290!2sFoyer%20Fattouma%20Bourguiba!5e0!3m2!1sfr!2stn!4v1707864005197!5m2!1sfr!2stn"
        style={{ border: 0 }}
        width="400" height="250"
        allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
      </iframe>

    </div>


  </div>
</div>
 * 
 * 
 * 
 * 
 *    <div className='bgtransport'>  </div>
      <div className='titretransport' >
        <h1 className='isimmtransport'>Vie Universitaire </h1>
        <h5 className='paratransport'>
          <Link className='linktransport' to="/">Accueil</Link> <span>{'>'}</span> <Link className='linktransport'>Vie étudiante</Link> <span>{'>'}</span> <Link className='linktransport'
           to="/Transport">Vie Universitaire</Link>
        </h5>
      </div>
 *     <div className='transport'>
      <div className='TITLETRANSPORT'>Transport Publique:</div>
      <div class="w3-row-padding">
      <div class="w3-third">
*        <div className='transport1'>
            <h5>Station Métro :</h5>
            <div className='imagemetro'>    
                 <img src={metro} alt="metro" />               
             </div>
            </div>
        </div>
        
        <div class="w3-third">
        <div className='transport2'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.1931850458604!2d10.822715775254693!3d35.77063062505867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130212ca531694fb%3A0x927f1b1f8d3f7082!2sMonastir!5e0!3m2!1sfr!2stn!4v1707857074387!5m2!1sfr!2stn" 
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              width="400" height="250" >

              </iframe>
        </div>
        </div>
        </div>
        </div>
 */